<template>
  <section>
    <div class="tip" style="margin:0 0 0 20px">* 项目基本资料</div>
    <!-- <div class="clear">
      <el-col :span="12">
        <el-form-item label="项目编号">
          <el-input size="small" :disabled="true" placeholder="请输入项目编号" v-model="project.number"></el-input>
        </el-form-item>
      </el-col>
    </div> -->
    <el-form-item label="项目需求单位">
      <el-input size="small" :disabled="true" v-model="project.deptName"></el-input>
    </el-form-item>
    <div class="clear">
      <el-col :span="12">
        <el-form-item label="项目负责人">
          <el-input size="small" :disabled="true" v-model="project.leader.name"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="联系方式">
          <el-input size="small" :disabled="true" v-model="project.leader.mobile"></el-input>
        </el-form-item>
      </el-col>
    </div>
    <el-form-item label="项目名称">
      <el-input size="small" v-model="project.name" :disabled="true" placeholder="请输入项目名称"></el-input>
    </el-form-item>
    <div class="clear">
      <el-col :span="12">
        <el-form-item label="开标时间">
          <el-date-picker size="small" value-format="yyyy-MM-dd" v-model="form.kbsj" type="date" placeholder="开标时间">
          </el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="中标单位">
          <el-input size="small" v-model="form.zbdw" placeholder="请输入中标单位"></el-input>
        </el-form-item>
      </el-col>
    </div>
    <div class="clear">
      <el-col :span="12">
        <el-form-item label="中标价(元)">
          <el-input size="small" type="number" v-model="form.zbj" placeholder="请输入中标价(元)"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="下浮值(%)">
          <el-input size="small" type="number" v-model="form.xfz" placeholder="请输入下浮值(%)"></el-input>
        </el-form-item>
      </el-col>
    </div>

  </section>
</template>

<script>
  export default {
    props: ['project', 'formByFather', 'userData'],
    data() {
      return {
        form: {},
      }
    },
    mounted() {
      this.form = this.formByFather
    },
    methods: {
      getFromData() {
        return this.form
      }
    },
    watch: {
      formByFather() {
        this.form = this.formByFather
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/page/form/inviteResult.vue